export default {
    ajaxRequest: null,
	popinSpotsEl: null,
	Popin: null,
	popinSpotsInstance: null,

	init: function(Popin){

        this.popinSpotsEl = document.querySelector('.js-popin-spots');
        this.Popin = Popin;

		if (this.popinSpotsEl) {
			this.initSpotsPopin();
		}
	},

    initSpotsPopin: function() {
		if (!this.popinSpotsEl) {
			return;
		}

		this.popinSpotsInstance = new this.Popin(this.popinSpotsEl, {
			openBtnCSSSelector: '.js-spot-button',
			closeBtnCSSSelector: '.js-popin-spots-close',
			popinBackCSSSelector: '.js-popin-spots-back',
			popinContentCSSSelector: '.js-popin-spots-content'
		})

		this.popinSpotsInstance.on('opened', (event) => {
			const spotDatas = event.detail.clickedEl.getAttribute('data-spot');
			if (spotDatas) {
				this.displaySpotsHtml(spotDatas);
			} else {
				console.error('No spots data found on button')
			}
		})
	},

	displaySpotsHtml: function(spotDatas) {
		spotDatas = JSON.parse(decodeURIComponent(spotDatas));
		if (!spotDatas) {
			return;
		}

		const template = `
			<div class="spotDetails">
				<div class="spotDetailsLogo">
					${spotDatas.image ? `
						<div class="spotDetailsLogo__media">
							<img src="${spotDatas.image}" alt="${spotDatas.alt}" class="spotDetailsLogo__media__image">
						</div>
					` : ''}
					<div class="spotDetailsLogo__title">${spotDatas.title}</div>
					${spotDatas.description ? `
						<div class="spotDetailsLogo__description">${spotDatas.description}</div>
					` : ''}
				</div>
				<div class="spotDetailsList">
					${spotDatas.places.map(place => `
						<div class="spotDetailsList__item">
							<svg class="icon icon-pin-filled"><use href="#icon-pin-filled"></use></svg>
							<span>${place.title}</span>
						</div>
					`).join('')}
				</div>
			</div>
		`;

		const spotsBody = this.popinSpotsInstance.el.querySelector('.js-popin-spots-body');
		if (spotsBody) {
			spotsBody.innerHTML = template;
		}
	},
	
    getSpotsAjax: function(post_id) {

		if (this.ajaxRequest) {
			this.ajaxRequest.abort();
		}

		const form_data = new FormData();
		form_data.append('action', 'get_exhibitor_spots');
		form_data.append('post_id', post_id);

        const resultContainer = document.querySelector('.js-popin-spots-body')

		this.ajaxRequest = $.ajax({
			url: wordpress_vars.ajax_url,
			type: 'POST',
			contentType: false,
			processData: false,
			data: form_data,
			complete: () => {
				this.ajaxRequest = null;
			}
		})
			.done(response => {
				if (resultContainer) {
                    resultContainer.innerHTML = response;
                }
			})
			.fail(() => {
				console.log("ajax failed");
			})
	},
}